<template>
    <div>
        <div class="d-flex align-items-center mb-3">
            <i class="fas fa-layer-group text-muted font-size-16 mr-2"></i>
            <p class="text-uppercase text-muted font-size-12 font-weight-bold h6 mb-0">
                {{ $t('module.module') }}
            </p>
        </div>
        <div class="row mb-5">
            <div
                v-for="(item, index) in coreItems"
                :key="index"
                class="col-12 col-md-3 mb-3"
            >
                <component
                    :is="item.externalLink && (item.route || item.externalUrl) ? 'a' : item.route ? 'router-link' : 'div'"
                    v-bind="getLinkProps(item)"
                >
                    <div
                        class="module-card bg-white position-relative overflow-hidden card-border-radius-14 pt-2"
                    >
                        <div
                            v-if="item.maintenance"
                            class="ribbon-wrapper"
                        >
                            <div class="ribbon font-weight-bold text-uppercase h6">
                                {{ $t('label.maintenance') }}
                            </div>
                        </div>
                        <div class="card-body d-flex flex-column">
                            <div class="mb-3">
                                <i
                                    :class="[
                                        'mdi',
                                        item.icon,
                                        `text-${item.color}`,
                                        `bg-soft-${item.color}`,
                                        'module-icon',
                                    ]"
                                ></i>
                            </div>

                            <div class="d-flex justify-content-between align-items-center">
                                <p class="font-weight-bold h5 text-dark mb-0">
                                    {{ item.label }}
                                </p>

                                <i class="mdi mdi-chevron-right text-muted module-arrow font-size-16"></i>
                            </div>
                        </div>
                    </div>
                </component>
            </div>
        </div>
        <template v-if="minorItems.length">
            <div class="d-flex align-items-center mb-3 pt-3">
                <i class="fas fa-cog text-muted font-size-16 mr-2"></i>
                <p class="text-uppercase text-muted font-size-12 font-weight-bold h6 mb-0">
                    {{ $t('module.configuration') }}
                </p>
            </div>
            <div class="row">
                <div
                    v-for="(item, index) in minorItems"
                    :key="index"
                    class="col-12 col-md-3 mb-3"
                >
                    <component
                        :is="item.externalLink && (item.route || item.externalUrl) ? 'a' : item.route ? 'router-link' : 'div'"
                        v-bind="getLinkProps(item)"
                    >
                        <div
                            class="module-card module-card-minor bg-white position-relative overflow-hidden card-border-radius-14 pt-2"
                        >
                            <div
                                v-if="item.maintenance"
                                class="ribbon-wrapper"
                            >
                                <div class="ribbon font-weight-bold text-uppercase h6">
                                    {{ $t('label.maintenance') }}
                                </div>
                            </div>

                            <div class="card-body d-flex flex-column">
                                <div class="mb-3">
                                    <i
                                        :class="[
                                            'mdi',
                                            item.icon,
                                            `text-${item.color}`,
                                            `bg-soft-${item.color}`,
                                            'module-icon',
                                        ]"
                                    ></i>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <p class="font-weight-semibold h6 text-secondary mb-0">
                                        {{ item.label }}
                                    </p>

                                    <i class="mdi mdi-chevron-right text-muted module-arrow font-size-16"></i>
                                </div>
                            </div>
                        </div>
                    </component>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        menuItems: {
            type: Array,
            required: true,
        },
    },
    methods: {
        getLinkProps(item) {
            if (item.externalLink && (item.route || item.externalUrl)) {
                return {
                    href: item.route ? this.$router.resolve({ name: item.route }).href : item.externalUrl,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                };
            }
            if (item.route) {
                return { to: { name: item.route } };
            }
            return {};
        },
    },
    computed: {
        coreItems() {
            return this.menuItems.filter(item => item.core);
        },
        minorItems() {
            return this.menuItems.filter(item => !item.core);
        },
    },
};
</script>

<style scoped>

.module-card {
    /* min-height: 100px; */
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.04);
    transition: all 0.2s ease-in-out;
}

.module-card:hover {
    transform: translateY(-3px);
    border-color: rgba(0, 174, 255, 0.35);
    box-shadow: 0 8px 20px rgba(0, 174, 255, 0.12);
}

.module-card-minor {
    /* min-height: 100px; */
}

.module-icon {
    font-size: 22px;
    border-radius: 0.5rem;
    padding: 0.45rem 0.75rem;
}

.module-arrow {
    transition: transform 0.2s ease-in-out;
}

.module-card:hover .module-arrow {
    transform: translateX(4px);
}

.ribbon-wrapper {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 90px;
    overflow: hidden;
    pointer-events: none;
    z-index: 2;
}

.ribbon {
    position: absolute;
    top: 24px;
    right: -42px;
    width: 150px;
    transform: rotate(45deg);
    text-align: center;
    font-size: 0.62rem;
    line-height: 1.1;
    padding: 5px 0;
    color: #343a40;
    background: #f1f3f5;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
}
</style>